import React from "react"

export type NavigationFunction = (path: string) => void

type NavigationContextValue = {
  navigate?: NavigationFunction
}

export const NavigationContext = React.createContext<NavigationContextValue>({})

export const NavigationProvider = ({
  children,
  navigate,
}: {
  children: React.ReactNode
  navigate?: NavigationFunction
}) => {
  return <NavigationContext.Provider value={{ navigate }}>{children}</NavigationContext.Provider>
}

export const useNavigation = () => {
  const context = React.useContext(NavigationContext)
  return context.navigate
}
